<script  lang="js">
export default {
  name: 'glp-tab-pane',
  functional: true,
  render (createElement, context) {
    const data = {
      props: context.props
    }
    return createElement('el-tab-pane', data, [context.scopedSlots.default && context.scopedSlots.default()])
  }
}
</script>
